import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, messageErreur } from "@/lib/api";
import { FormulaireMotDePasse } from "@/components/FormulaireMotDePasse";

export default function Reinitialisation() {
  const { token } = useParams();
  const navigate = useNavigate();
  const valider = async (mot_de_passe) => {
    try {
      const { data } = await api.post("/auth/reinitialiser", { token, mot_de_passe });
      toast.success(data.message);
      navigate("/connexion");
    } catch (e) { throw new Error(messageErreur(e)); }
  };
  return <FormulaireMotDePasse titre="Nouveau mot de passe" sousTitre="Choisissez un nouveau mot de passe pour votre compte." bouton="Enregistrer" onValider={valider} />;
}
